window.powerReviewData = window.powerReviewData || [];

// Initialize Power Reviews.
function initializePowerReviews() {
    const prData = [];
    // Check if Onetrust is ready or not.
    const oneTrustReady = new Promise((resolve) => {
      // Set a timer, which checks the window.OnetrustActiveGroups variable in every 100ms.
      const checkOneTrust = setInterval(() => {
        // Once it has a value.
        if (typeof window.OnetrustActiveGroups !== 'undefined') {
          // We clear the timer.
          clearInterval(checkOneTrust);
          // And resolve the Promise.
          resolve(window.OnetrustActiveGroups.indexOf('C0002') !== -1);
        }
      }, 100);
    });

    // Check if Power Review is ready or not.
    const powerReviewsReady = new Promise((resolve) => {
      // Set a timer, which checks the POWERREVIEWS variable in every 100ms.
      const checkPowerReviews = setInterval(() => {
        // Once it has a value.
        if (typeof POWERREVIEWS !== 'undefined') {
          // We clear the timer.
          clearInterval(checkPowerReviews);
          // And resolve the Promise.
          resolve();
        }
      }, 100);
    });

    // We should wait for both Promises to be resolved.
    Promise.all([oneTrustReady, powerReviewsReady]).then(([OneTrustC0002]) => {
      // Display PowerReviews for all of the products.
      document.querySelectorAll('[data-product-id] .power-reviews__container:not(.power-reviews-processed)').forEach((powerReviewsContainer, index) => {
        // Get the Product ID.
        const productId = powerReviewsContainer.closest('[data-product-id]')?.dataset.productId;

        // Check if the powerReviewsContainer has a children.
        const children = powerReviewsContainer.children;
        if (children.length > 0) {
            Array.from(children).forEach(child => {
                // Get the id attribute of the children element.
                if (child.id) {
                    // Get the Review Container ID.
                    const reviewContainerId = child.id;

                    // Prepare the review related data.
                    prData.push({
                      api_key: theme.settings.pr_merchant_api_key,
                      locale: theme.settings.language,
                      ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
                      merchant_group_id: theme.settings.pr_merchant_group_id,
                      merchant_id: theme.settings.pr_merchant_id,
                      page_id: productId,
                      enable_content_collection_modal: false,
                      sm_data: OneTrustC0002 ? "ENABLED" : "DISABLED",
                      enable_front_end_iovation_validation: OneTrustC0002,
                      components: {
                        CategorySnippet: reviewContainerId
                      }
                    });
                }
            });
        }

        powerReviewsContainer.classList.add('power-reviews-processed');
      });

      // Iterate over the powerReviewData array.
      window.powerReviewData.forEach(item => {
        // Set the OneTrustC0002 dependent variables.
        item['sm_data'] = OneTrustC0002 ? "ENABLED" : "DISABLED";
        item['enable_front_end_iovation_validation'] = OneTrustC0002;
        item['ENABLE_CLIENT_SIDE_STRUCTURED_DATA'] = false; // <-- force disable
        prData.push(item);
      })

      // Reset the powerReviewData to an empty array.
      window.powerReviewData = [];

      if (prData.length > 0) {
        // Initialize PowerReviews.
        POWERREVIEWS.display.render(prData);
      }
    }).catch((error) => {
      console.error('PowerReviews or OneTrust error:', error);
    });
  }

  // When the DOM is loaded.
  document.addEventListener('DOMContentLoaded', initializePowerReviews);
  // When the recommendations are loaded.
  document.addEventListener('recommendations:loaded', initializePowerReviews);